import "./App.css";
import Input from "./Input";

function App() {
  return <Input />;
}

export default App;
